import React from 'react';
import css from './css.module.less';
import { SizeFittingTable, Button } from 'src/components/Antd';
import ModalHoc from 'src/constrains/ModalHOC';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import Modal from './Modal';
import { generateColumns } from './utils';

const CustomerTableInner = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { value, onChange, id, tableId, modalOp, dbUuid, tags, disabled } =
    props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp || {};
  const [customers, setCustomers] = React.useState(value || []);
  const isNoData = (customers || []).length === 0;

  React.useEffect(() => {
    if (value !== customers) {
      setCustomers(value || []);
    }
  }, [value]);

  const handleOnChange = (att) => {
    if (onChange) {
      onChange(att);
    }
  };

  const handleOnDelete = (index) => {
    const _customers = [...customers];
    _customers.splice(index, 1);
    setCustomers(_customers);
    handleOnChange(_customers);
  };

  const handleOnDeleteAll = () => {
    setCustomers([]);
    handleOnChange([]);
  };

  const handleOnModalConfirm = (confirmedCustomers) => {
    setCustomers(confirmedCustomers);
    handleOnChange(confirmedCustomers);
    if (onModalCancel) {
      onModalCancel();
    }
  };

  const handleOnEdit = () => {
    if (setModalContent && setShowModal && setModalTitle) {
      setModalContent(
        <Modal
          selected={customers}
          onCancel={onModalCancel}
          onConfirm={handleOnModalConfirm}
          dbUuid={dbUuid}
          tags={tags || []}
        />,
      );
      setShowModal(true);
      setModalTitle(getI18n('voucher.storeVoucherDetail.selectCustomer'));
    }
  };

  const cols = generateColumns(getI18n, handleOnDelete, disabled);

  return (
    <div className={css.customerTableContainer} id={id}>
      <SizeFittingTable
        id={tableId || 'SalesChannelCustomerTable' + id}
        dataSource={customers}
        pagination={false}
        columns={cols}
        rowKey={'uuid'}
        scroll={{ x: 'max-content', y: 560 }}
      />
      <div className={css.btnsContainer}>
        <Button
          className={css.addBtn}
          type='primary'
          onClick={handleOnEdit}
          disabled={disabled}>
          {getI18n('voucher.storeVoucherDetail.selectCustomer')}
        </Button>
        {!isNoData && (
          <Button
            className={`${css.deleteBtn} ${disabled ? css.disabled : ''}`}
            onClick={handleOnDeleteAll}
            disabled={disabled}>
            {getI18n('general.dragNDropColumns.delete_all')}
          </Button>
        )}
      </div>
    </div>
  );
};

const CustomerTableComponent = ModalHoc(CustomerTableInner, { width: 900 });

export default CustomerTableComponent;
